(ns storrito.instagram.story.editor.music-search
  (:require [cljs.core.async :refer [<!]]
            [app.util.api-request :as api])
  (:require-macros [cljs.core.async.macros :refer [go]]))

(defn search-tracks
  "The request either searches by text ({:query \"...\"}) or fetches a
   browse category ({:category \"trending\"}), like the tabs of the
   Instagram app's music sticker."
  [request]
  (go
    (let [response (<! (api/request {:request-method :post
                                     :url "/api/ig-music-search"
                                     :transit-params (select-keys request
                                                                  [:query
                                                                   :category
                                                                   :account-id])}))]
      (:body response))))
